
export class UsuarioActual {
  token: string;
  sidCliente: string;
  usuarioTipo: string;
  usuarioCodigo: string;
  usuarioCorreoInterno: string;
  usuarioLogin: string;
  usuarioHostName: string;
  usuarioIpAddress: string;
  usuarioEstado: string;
  usuarioLoginBaseDatos: string;
  usuarioUniqueIdString: string;
  usuarioUniqueIdInteger: number;
  personaId: number;
  personaTipoDocumento: string;
  personaNroDocumento: string;
  personaNombreCompleto: string;
  personaNombres: string;
  personaApellidos: string;
  personaApellidoPaterno: string;
  personaApellidoMaterno: string;
  personaIdJefeQuienReporta: string;
  areaCodigo: string;
  areaNombre: string;
  clienteCodigo: number;
  clienteNombre: string;
  cargoCodigo: string;
  cargoNombre: string;
  paisCodigo: string;
  paisNombre: string;
  aplicacionCodigo: string;
  aplicacionNombre: string;
  companiaSocioCodigo: string;
  companiaSocioNombre: string;
  clave: string;
  seguridadTipo: string;
  preferenciasDataBase: string;
  preferenciasEmpresa: string;
}
